// Third-party Library
import { useState } from "react"
import {
    GoogleMap,
    useJsApiLoader
} from '@react-google-maps/api';

// Constant
import { APP_CONFIG } from "../../../../config";

// Components
import VehicleMarkers from "../../../LiveTrackingMap/components/VehicleMarkers";
import { MapInitialiserWithVehicle } from "../../../LiveTrackingMap/components/MapInitialiserWithVehicle";

const GoogleMapPage = ({
    vid,
    location
}) => {

    const [mapRef, setMapRef] = useState(null)


    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: APP_CONFIG.APP_GOOGLE_MAP_API_KEY,
        libraries: ['drawing']
    })
    
    MapInitialiserWithVehicle(location, mapRef)

    return isLoaded
            &&
            <GoogleMap
                id='googles-map'
                mapContainerStyle={{
                    // height: '100vh',
                    borderRadius: '10px'
                }}
                onLoad={ref => setMapRef(ref)}
            >
                <VehicleMarkers vid={vid} mapRef={mapRef} />
            </GoogleMap>
}

export default GoogleMapPage